import { useEffect } from 'react';
import { IFormConfig } from 'js/components/common/Form/types';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFormData = ({
    formConfig, formName, isRegistration
}: { formConfig: IFormConfig; formName: string; isRegistration: boolean }) => {
    const dispatch = useDynamicReducerDispatch();

    useEffect(() => {
        if (!formConfig) {
            return;
        }

        const { formRules, submitButtonName, backButtonName, nextButtonName, id } = formConfig;
        const formSteps = formConfig.formSteps.map((formStep) => helpers.getFormFields(formStep));
        const formFields = formSteps.flat();

        dispatch(actions.setFormData({
            formName,
            formId: id,
            isRegistration,
            backButtonName,
            nextButtonName,
            submitButtonName,
            formFields,
            formSteps,
            formRules: helpers.getFormRules(formRules, formFields)
        }));
    }, [dispatch, formConfig, formName, isRegistration]);

    return null;
};
